let videosWrapper = document.querySelectorAll('.video')

if (videosWrapper.length) {
  videosWrapper.forEach(videoWrapper => {
    const btnPlayPause = videoWrapper.querySelector('.play-pause-btn')
    const btnVolume = videoWrapper.querySelector('.volume-btn')
    const video = videoWrapper.querySelector('video')

    if (btnPlayPause) {

      if (video.paused) {
        btnPlayPause.classList.add('paused')
      } else {
        btnPlayPause.classList.remove('paused')
      }

      btnPlayPause.onclick = (e) => {
        e.preventDefault()

        if (video.paused) {
          video.play()
        } else {
          video.pause()
        }
      }

      video.onpause = () => {
        btnPlayPause.classList.add('paused')
      }

      video.onplay = () => {
        btnPlayPause.classList.remove('paused')
      }
    }

    if (btnVolume) {

      if (video.muted) {
        btnVolume.classList.add('muted')
      } else {
        btnVolume.classList.remove('muted')
      }

      btnVolume.onclick = (e) => {
        e.preventDefault()
        video.muted = !video.muted
      }

      video.onvolumechange = () => {
        if (video.muted) {
          btnVolume.classList.add('muted')
        } else {
          btnVolume.classList.remove('muted')
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./scripts/video.js